<template>
  <button class="btn btn--primary btn--large" v-if="!props.isLoading">
    <span class="btn__label">
      <slot></slot>
    </span>
  </button>
  <div class="form__loading" v-if="props.isLoading">
    <span class="text">{{ _e('Enviando') }}</span>
    <span class="icon">

    </span>
  </div>
</template>
<script setup>
import { _e } from '../../helpers/l10n.js';

const props = defineProps({
  isLoading: {
    type: Boolean,
    default: false,
  }
});
</script>
